/**
 * @desc 保存计价方式
 */
import { PricingMethodForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SavePricingMethodParameter = PricingMethodForm

const method = 'POST'
const url = '/trade/pricingMethod'

export const savePricingMethodApi = (
  data?: SavePricingMethodParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

savePricingMethodApi.method = method
savePricingMethodApi.url = url
